const ilshift = (a, b) => {
	// eslint-disable-next-line no-return-assign
	return (a <<= b);
};

export default ilshift;
